export default "__VITE_ASSET__1a2551f1__"